import React from "react";
import CenteredColumnLayout from "./CenteredColumnLayout";
import RowColLayout from "./RowColLayout";

const LandingButtons = ({ imagen, backColor, backColor2 = "white" }) => {

    return (
        <div className="landingButtons m-0 p-0 d-flex justify-content-center align-items-center" style={{ backgroundColor: backColor2, height: "100%", width: "100%", borderRadius: "18px", borderstyle: "dashed" }}>

                <div className="row d-flex justify-content-center align-items-center m-0 p-0" style={{ backgroundColor: "transparent"}}>
                    <div className="col-12 d-flex justify-content-center align-items-center m-0 p-0">
                        <img src={imagen} alt="" style={{height: "auto", width: "90%", minHeight: "65px"}} />
                    </div>
                </div>

        </div>
    );
};

export default LandingButtons;
